import { createContext, useContext } from "react";
import type { LinkedEntity } from "@/api";
import type { SavedDraft } from "./draftModel";

export interface DraftContextValue {
  sessionUuid?: string;
  /** Entities created from or opened in this chat (the session's `linkedEntities`). */
  linked: LinkedEntity[];
  /** Every saved draft of the chat, for the newest-per-entity rule. */
  saved: SavedDraft[];
  /** A reply is on its way: cards wait for it before acting. */
  streaming: boolean;
  /** Someone the chat was shared with: cards are read-only. */
  readOnly: boolean;
  /** Answer a draft's questions with a normal message. */
  onAnswer?: (text: string) => void;
}

const DraftContext = createContext<DraftContextValue>({ linked: [], saved: [], streaming: false, readOnly: true });

export const DraftProvider = DraftContext.Provider;
export const useDraftContext = () => useContext(DraftContext);
